import React from 'react';
import getAvailableServices from '../../utils/getAvailableServices';

class MapListItem extends React.Component {
    clickHandler = e => {
        e.stopPropagation();

        this.props.onClick(this.props.item);
    };

    noopClickHandler = e => {
        e.preventDefault();
    };

    render() {
        const { item, labels, services, language } = this.props;
        const availableServices = getAvailableServices(
            item,
            services,
            language,
            'popup'
        );

        let openingHours = '';

        // TODO: Remove below logic when realtime api is in production
        if (item.machines && item.machines.length) {
            const machineWithOpeningHours = item.machines
                .filter(machine => machine.opening_hours !== '')
                .slice(-1)[0];

            if (machineWithOpeningHours) {
                openingHours = machineWithOpeningHours.opening_hours;
            }
        }

        if (item.opening_info) {
            openingHours = item.opening_info;
        }

        let screenReaderLabel = `${item.address1} ${item.address2 ? item.address2 : ''} ${item.city}`;
        if (availableServices.withdrawalServices) {
            screenReaderLabel += `, ${labels.withdrawal} ${availableServices.withdrawalServices}`;
        }
        if (availableServices.depositServices) {
            screenReaderLabel += `, ${labels.deposit} ${availableServices.depositServices}`;
        }
        if (openingHours !== '') {
            screenReaderLabel += `, ${labels.businessHours} ${openingHours}`;
        }

        return (
            <li
                className="MapListItem"
                data-identifier={item.identifier}
                onClick={this.clickHandler}
            >
                <a
                    className="MapListItem__Link"
                    href={`?marker=${item.identifier}`}
                    onClick={this.noopClickHandler}
                    aria-label={screenReaderLabel}
                >
                    <h2
                        aria-hidden={true}
                        className="MapListItem__Title"
                        dangerouslySetInnerHTML={{
                            __html: item.address2
                                ? `${item.address1}<br>${item.address2}, ${
                                    item.city
                                }`
                                : `${item.address1}, ${item.city}`
                        }}
                    />
                    {availableServices.withdrawalServices !== '' && (
                        <div
                            aria-hidden={true}
                            className="MapListItem__Service"
                            dangerouslySetInnerHTML={{
                                __html: `<strong>${labels.withdrawal}:</strong> ${
                                    availableServices.withdrawalServices.join('')
                                }`
                            }}
                        />
                    )}
                    {availableServices.depositServices.length !== 0 && (
                        <div
                            aria-hidden={true}
                            className="MapListItem__Service"
                            dangerouslySetInnerHTML={{
                                __html: `<strong>${labels.deposit}:</strong> ${
                                    availableServices.depositServices.join('')
                                }`
                            }}
                        />
                    )}
                    {openingHours !== '' && (
                        <div
                            aria-hidden={true}
                            className="MapListItem__OpeningHours"
                            dangerouslySetInnerHTML={{
                                __html: `<strong>${labels.businessHours}:</strong> ${
                                    openingHours
                                }`
                            }}
                        />
                    )}
                    {!item.is_open && (
                        <p className="MapListItem__Note">{labels.isClosed}</p>
                    )}
                </a>
            </li>
        );
    }
}

MapListItem.defaultProps = {};

export default MapListItem;
